import { FieldTimeOutlined } from '@ant-design/icons';
import { Divider, Layout } from "antd";
import { useState } from 'react';
import { TaskExec } from "../../apis/mgmt/api";
import { DataViewProps } from "../common/DataView";
import { TaskExecTree } from './TaskExecTree';

const { Header, Content } = Layout;

export function TaskExecPanel(props: 
    DataViewProps<TaskExec> & {
        onShowLog?: (taskExec: TaskExec) => void,
        onShowFileLog?: (taskExec: TaskExec) => void
    }
) {

    const [ data, setData ] = useState(props.data);

    return data && (
        <Layout>
            <Header>
                <Divider><FieldTimeOutlined /><small>
                    {data?.started && ` From ${new Date(data?.started).toLocaleString()}`}
                    {data?.finished && ` to ${new Date(data?.finished).toLocaleTimeString()}` || '...' }
                    {data?.finished && data?.stopped && ' (stopped)' || '' }
                    </small></Divider>
            </Header>
            <Content>
                <TaskExecTree data={data} setData={setData} 
                    onShowLog={props.onShowLog} 
                    onShowFileLog={props.onShowFileLog}
                />
            </Content>
        </Layout> 
    ) || null;

}